import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS, getFormDefaults } from '../../formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const history = useHistory();
	const data = getFormDefaults(app.website);
	const { requestCreateAppUpdateInfo, getLudoVersionNumberOptions } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MAX_VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MIN_VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });

	const createAppUpdateInfo = async (createdData: any) => {
		setShowLoader(true);
		try {
			await requestCreateAppUpdateInfo(createdData);
			showAlert('App Update Info created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createAppUpdateInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
